import EmailNotificationForm from './EmailNotificationForm'
import styles from './EmailNotification.css'
import {connect} from 'react-redux'
import * as actEmailNotification from 'actions/setting/emailNotification'
import Header from './Header'
import {
  askConfirmAction
} from 'actions/confirm-action'
import {browserHistory} from 'react-router'
import {isDirty, getFormValues} from 'redux-form'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {PageWrapper} from 'components/wrappers/pages'
import DeleteRecipientModal from './EmailNotificationForm/DeleteRecipientModal'

class EmailNotification extends React.Component {
  render () {
    let {showDeleteRecipientModal, deletedRecipient} = this.props.data.setting.emailNotification
    let {emailNotificationForm} = this.props
    return (
      <PageWrapper>
        <div className='row'>
          <div className='col-xs-12 col-md-6'>
            <Header title='manage email notification' />
            <p className={styles.description}>Receive emails on new products or how your business is performing.
              Emails are automatically sent to your account email.</p>
            <EmailNotificationForm onSubmit={this._onSubmit} />
          </div>
        </div>
        <DeleteRecipientModal
          showDeleteRecipientModal={showDeleteRecipientModal}
          deletedRecipient={deletedRecipient}
          dispatch={this.props.dispatch}
          emailNotificationForm={emailNotificationForm}
        />
        <ConfirmActionModal />
      </PageWrapper>)
  }

  _onSubmit = (values) => {
    let {profile: {business: {setting}}} = this.props.data.setting.emailNotification
    setting.daily_sales_summary = values.dailySalesSummary
    setting.inventory_alerts = values.inventoryAlerts
    setting.product_updates = values.productUpdates
    setting.setting_alert_recipients = values.settingAlertRecipients
    this.props.dispatch(actEmailNotification.submitForm({settings: {...setting}}))
  };

  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      browserHistory.listenBefore((location) => {
        if (!this.props.data.isDirtyForm) {
          this.props.dispatch(actEmailNotification.changePage(location.pathname))
        } else {
          // negate the change location, instead use sagas to handle the change location
          this.props.dispatch(askConfirmAction(actEmailNotification.changePage(location.pathname)))
        }
        return false
      })
      this.props.dispatch(actEmailNotification.pageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }
}

function mapStateToProps (state) {
  return {
    emailNotificationForm: getFormValues('emailNotification')(state),
    data: {
      isDirtyForm: isDirty('emailNotification')(state),
      setting: {
        emailNotification: state.setting.emailNotification
      },
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(EmailNotification)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/EmailNotification/EmailNotification.js